import { render } from "./Pagination.vue?vue&type=template&id=a2bd47be"
import script from "./Pagination.vue?vue&type=script&lang=js"
export * from "./Pagination.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/derolfgroep-ict/derolfgroep-ict/web/app/themes/rolfhardware/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__